import { render, staticRenderFns } from "./ShowGamDetailsModal.vue?vue&type=template&id=aea6e5bc"
import script from "./ShowGamDetailsModal.vue?vue&type=script&lang=js"
export * from "./ShowGamDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ShowGamDetailsModal.vue?vue&type=style&index=0&id=aea6e5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports